<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">

    <!-- Header: título + botões de ação -->
    <div class="row mb-4">
      <div class="col-12 col-md-6">
        <h1 class="title-default">Transferências de produtos</h1>
        <p class="welcome-message">
          <button mat-icon-button (click)="voltar()" matTooltip="Voltar para Controle de Estoque">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Gerencie a movimentação de estoque entre unidades e centros de distribuição
        </p>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu" type="button">
          @if (selection.hasValue()) {
            <span>Ações ({{ selection.selected.length }})</span>
          } @else {
            <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #acoesMenu="matMenu">
          <button mat-menu-item [disabled]="!selection.hasValue() || !temSelecionadasExcluiveis" (click)="excluirSelecionadas()">
            <span class="material-symbols-outlined">delete</span>
            <span>Excluir selecionadas</span>
          </button>
        </mat-menu>
        <button mat-flat-button class="btn-primary" type="button" (click)="nova()">
          <span class="material-symbols-outlined">add</span>
          Nova Transferência de Estoque
        </button>
      </div>
    </div>

    <!-- Barra de busca -->
    <form (ngSubmit)="clickPesquisar()">
      <div class="row search-area align-items-center">
        <div class="col-12 col-md-5">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" [(ngModel)]="pesquisa" name="pesquisa"
              placeholder="Pesquise por origem, destino..." />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-7 d-flex align-items-center gap-2 flex-wrap">
          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtrarMenu"
            [matBadge]="qtdFiltrosAtivos" [matBadgeHidden]="qtdFiltrosAtivos === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtrarMenu="matMenu">
            <div class="filtro-menu-content" (click)="$event.stopPropagation()">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="filtroStatus" name="filtroStatus">
                  <mat-option [value]="null">Todos</mat-option>
                  @for (s of statuses; track s.idStatusTransferencia) {
                    <mat-option [value]="s.idStatusTransferencia">{{ s.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <button mat-flat-button class="btn-primary w-100 mt-2" type="button" matMenuClose (click)="clickPesquisar()">
                Aplicar
              </button>
            </div>
          </mat-menu>

          <button mat-stroked-button class="btn-filter" type="button" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    <!-- Loading -->
    @if (isLoading && dataSource.data.length === 0) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (!isLoading && dataSource.data.length === 0) {
      <app-empty-list
        title="Nenhuma transferência encontrada"
        subTitle="Tente ajustar os filtros de busca">
      </app-empty-list>
    } @else {
      <!-- Desktop table -->
      <div class="desktop-view">
        <table mat-table [dataSource]="dataSource" matSort class="w-100">

          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-checkbox">
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="w-checkbox">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="datetimeInclusao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Data</th>
            <td mat-cell *matCellDef="let row">{{ row.datetimeInclusao | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="origem">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Origem</th>
            <td mat-cell *matCellDef="let row">
              <div>{{ row.descricaoOrigem ?? ('Local #' + row.idLocalizacaoEstoqueOrigem) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="destino">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Destino</th>
            <td mat-cell *matCellDef="let row">
              <div>{{ row.descricaoDestino ?? ('Local #' + row.idLocalizacaoEstoqueDestino) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span [class]="statusBadgeClass(row.idStatusTransferencia)">
                {{ row.descricaoStatus }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="w-actions text-center">Ações</th>
            <td mat-cell *matCellDef="let row" class="w-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações"
                (click)="$event.stopPropagation()">
                <span class="material-symbols-outlined">more_horiz</span>
              </button>
              <mat-menu #menuRow="matMenu">
                <button mat-menu-item (click)="abrir(row)">
                  <span class="material-symbols-outlined">{{ row.idStatusTransferencia === statusTransferenciaEnum.Pendente ? 'edit' : 'visibility' }}</span>
                  <span>{{ row.idStatusTransferencia === statusTransferenciaEnum.Pendente ? 'Editar' : 'Visualizar' }}</span>
                </button>
                @if (row.idStatusTransferencia === statusTransferenciaEnum.Pendente || row.idStatusTransferencia === statusTransferenciaEnum.Concluido) {
                  <button mat-menu-item (click)="excluir(row)">
                    <span class="material-symbols-outlined">delete</span>
                    <span>Excluir</span>
                  </button>
                }
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <!-- Mobile cards -->
      <div class="mobile-view">
        @for (row of dataSource.data; track row.idTransferenciaEstoque) {
          <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(row)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)">
                </mat-checkbox>
                <div class="d-flex flex-column">
                  <span class="text-bold">{{ row.datetimeInclusao | date:'dd/MM/yyyy' }}</span>
                  <span [class]="statusBadgeClass(row.idStatusTransferencia)">{{ row.descricaoStatus }}</span>
                </div>
              </div>
              <button mat-icon-button [matMenuTriggerFor]="menuMobile" (click)="$event.stopPropagation()">
                <span class="material-symbols-outlined">more_horiz</span>
              </button>
              <mat-menu #menuMobile="matMenu">
                <button mat-menu-item (click)="abrir(row)">
                  <span class="material-symbols-outlined">{{ row.idStatusTransferencia === statusTransferenciaEnum.Pendente ? 'edit' : 'visibility' }}</span>
                  <span>{{ row.idStatusTransferencia === statusTransferenciaEnum.Pendente ? 'Editar' : 'Visualizar' }}</span>
                </button>
                @if (row.idStatusTransferencia === statusTransferenciaEnum.Pendente || row.idStatusTransferencia === statusTransferenciaEnum.Concluido) {
                  <button mat-menu-item (click)="excluir(row)">
                    <span class="material-symbols-outlined">delete</span>
                    <span>Excluir</span>
                  </button>
                }
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
              <div class="row">
                <div class="col-6 mb-1">
                  <small class="d-block text-secondary">Origem</small>
                  <span>{{ row.descricaoOrigem ?? ('Local #' + row.idLocalizacaoEstoqueOrigem) }}</span>
                </div>
                <div class="col-6 mb-1">
                  <small class="d-block text-secondary">Destino</small>
                  <span>{{ row.descricaoDestino ?? ('Local #' + row.idLocalizacaoEstoqueDestino) }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Ver Mais -->
      <div class="text-center mt-3">
        <button mat-button (click)="proximaPagina()" [disabled]="_ultimaPagina || isLoading">
          @if (isLoading) {
            <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
          } @else {
            <span class="material-symbols-outlined">expand_more</span>
            Ver Mais
          }
        </button>
      </div>
    }
  </div>
</div>
